import { Select } from "../ui/input";
import { useTenantStore } from "../../stores/tenant";

// Le compte connecté (courriel + déconnexion) vit UNIQUEMENT au pied de la
// barre latérale : l'afficher aussi ici faisait doublon.
export function Topbar({ onMenu, navOpen }: { onMenu?: () => void; navOpen?: boolean }) {
  const { available, currentTenantId, setTenant } = useTenantStore();

  return (
    <div className="topbar">
      <button
        className="topbar__menu"
        onClick={onMenu}
        aria-label={navOpen ? "Fermer le menu" : "Ouvrir le menu"}
        aria-expanded={navOpen ?? false}
        aria-controls="app-sidebar"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
          {navOpen ? (
            <>
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </>
          ) : (
            <>
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </>
          )}
        </svg>
      </button>

      <div className="topbar__left">
        {available.length > 0 ? (
          <label className="topbar__tenant">
            <svg
              className="topbar__tenant-icon"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.9"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M3 21h18" />
              <path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16" />
              <path d="M9 8h1M9 12h1M14 8h1M14 12h1M10 21v-4h4v4" />
            </svg>
            <Select
              className="topbar__tenant-select"
              value={currentTenantId ?? ""}
              onChange={(e) => setTenant(e.target.value)}
            >
              {available.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.name}
                </option>
              ))}
            </Select>
          </label>
        ) : (
          <span className="topbar__empty">Aucun établissement</span>
        )}
      </div>

      <div className="topbar__search">
        <svg
          className="topbar__search-icon"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="7" />
          <path d="M21 21l-4-4" />
        </svg>
        <input
          type="search"
          className="topbar__search-input"
          placeholder="Rechercher un appel, un client…"
          aria-label="Rechercher"
        />
      </div>

    </div>
  );
}
